import styles from "./style.module.css";

export const OutlineTabs = ({ tabs, tabSetter, currentTab }) => {
  return (
    <div className={styles.tabContainer}>
      <div className={styles.tabHeader}>
        {tabs.map((tab, index) => (
          <button
            key={tab.title}
            className={`${styles.tabButton} ${
              tabs[currentTab].title === tab.title
                ? styles.outlineActive
                : styles.inActive
            }`}
            onClick={() => tabSetter(index)}
          >
            {tab.title}
          </button>
        ))}
      </div>
      {tabs[currentTab].content}
    </div>
  );
};
